import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { MsalProvider } from "@azure/msal-react";
import NoSsr from "@mui/material/NoSsr";
import CssBaseline from "@mui/material/CssBaseline";
import { PersistGate } from "redux-persist/integration/react";
import { AuthProvider } from "./hooks/authContext";
import theme from "./styles/theme";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import App from "./bootstrap/App";
import { msalInstance } from "./services/authenticationService/msal";
import store from "./store";

const persistor = persistStore(store);

const AppWrapper = () => (
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <NoSsr>
          <MsalProvider instance={msalInstance}>
            <AuthProvider>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
              </ThemeProvider>
            </AuthProvider>
          </MsalProvider>
        </NoSsr>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<AppWrapper />);